import {StyleSheet} from 'react-native'

export default StyleSheet.create({
    image: {
        height: '100%',
        width: '100%'
    }
})